<template>
    <div
        class="pdf-navbar"
        :style="{ 'width': navbarWidth + 'px'}"
    >
        <v-container
            fluid
            class="pdf-navbar-content pa-2"
        >
            <v-row
                class="text-center justify-center"
                no-gutters
            >
                <div
                    class="pa-2 ml-2"
                >
                    <v-tooltip 
                        content-class="top"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                id="gtm-pdfviewer-cta-summary"
                                v-bind="attrs"
                                v-on="on"
                                small
                                fab
                                @click.prevent="togglePreviews()"
                            >
                                <v-icon>
                                    icon-list-bullets
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('pdfViewer.tooltips.summary') }}
                        </span>
                    </v-tooltip>
                </div>
                <div
                    class="pa-2 ml-2"
                >
                    <v-tooltip 
                        content-class="top"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                id="gtm-pdfviewer-cta-previous"
                                v-bind="attrs"
                                v-on="on"
                                small
                                fab
                                @click.prevent="previousPage()"
                            >
                                <v-icon>
                                    icon-arrow-up
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('pdfViewer.tooltips.previous') }}
                        </span>
                    </v-tooltip>
                </div>

                <div
                    class="pa-2 ml-2"
                >
                    <v-tooltip 
                        content-class="top"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-select
                                    class="white page-selector"
                                    id="gtm-pdfviewer-cta-pages"

                                    :items="indexPages"
                                    v-model="currentPage"
                                    :menu-props="{ top: true, offsetY: true }"
                                    dense
                                ></v-select>
                            </div>
                        </template>
                        <span>
                            {{ $t('pdfViewer.tooltips.pages') }}
                        </span>
                    </v-tooltip>
                </div>

                <div
                    class="pa-2 ml-2"
                >
                    <v-tooltip 
                        content-class="top"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                id="gtm-pdfviewer-cta-next"
                                v-bind="attrs"
                                v-on="on"
                                small
                                fab
                                @click.prevent="nextPage()"
                            >
                                <v-icon>
                                    icon-arrow-down
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('pdfViewer.tooltips.next') }}
                        </span>
                    </v-tooltip>
                </div>
                <div
                    v-if="$vuetify.breakpoint.smAndUp && !isSafariBrowser"
                    class="pa-2 ml-2"
                >
                    <v-tooltip 
                        content-class="top"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                id="gtm-pdfviewer-cta-print"
                                v-bind="attrs"
                                v-on="on"
                                small
                                fab
                                @click.prevent="printDocument"
                            >
                                <v-icon>
                                    icon-printer
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('pdfViewer.tooltips.print') }}
                        </span>
                    </v-tooltip>
                </div>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import printJS from "print-js";

    export default {
        name: 'PDFToolbar',
        props: {
            url: {
                type: String,
                required: true,
            },
            pages: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                currentPage: 1,
                zoom: 1,
                sidebarOpened: false,
                navbarWidth: null,
                screenWidth: null,
                isSafariBrowser: null
            }
        },
        mounted() {
            this.isSafariBrowser = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
            this.screenWidth = window.innerWidth;
            EventBus.$on('goToPage', (pageNumber) => { this.currentPage = pageNumber});
            EventBus.$on('updateSidebarStatus', sidebarStatus => this.sidebarOpened = sidebarStatus);
            let sidebarStatus;
            EventBus.$emit('getSidebarSatus', status => {
                sidebarStatus = status;
            });
            this.sidebarOpened = sidebarStatus;
            this.setNavigationBarWidth();
            window.addEventListener('resize', this.setNavigationBarWidth);
        },
        computed: {
            indexPages() {
                let array = [];
                if(this.pages){
                    for (let index = 0; index < this.pages.length; index++) {
                        array.push(index + 1);
                    }
                }
                return array;
            }
        },
        methods: {
            setNavigationBarWidth() {
                let sidebar = document.getElementById('sidebar');
                this.screenWidth = window.innerWidth;
                this.navbarWidth = this.screenWidth;
                if (sidebar && this.sidebarOpened)
                    this.navbarWidth -= sidebar.getBoundingClientRect().width;
            },
            nextPage(){
                this.currentPage = this.currentPage < this.pages.length ? this.currentPage + 1 : this.currentPage;
                EventBus.$emit('updateCurrentPage', this.currentPage);
            },
            previousPage(){
                this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : this.currentPage;
                EventBus.$emit('updateCurrentPage', this.currentPage);
            },
            scrollIntoCurrentPage() {
                if ((this.currentPage - 1) >= 0 || (this.currentPage - 1) <= this.pages.numPages)
                    document.getElementsByClassName('pdf-page')[this.currentPage - 1].scrollIntoView();
            },
            togglePreviews() {
                EventBus.$emit('togglePreviews');
            },
            printDocument() {
                printJS({printable: this.url, type: 'pdf'})
            }
        },
        watch: {
            currentPage: 'scrollIntoCurrentPage',
            zoom() {
                EventBus.$emit('updateZoom', this.zoom);
                this.scrollIntoCurrentPage();
            },
            sidebarOpened() {
                this.setNavigationBarWidth();
            }
        },
	};
</script>

<style lang="scss">
    @import "@/assets/scss/components/_pdf-viewer-toolbar.scss";
</style>



// WEBPACK FOOTER //
// src/components/pdfViewer/PDFToolbar.vue